// client/src/components/products/CategorySidebar.js
import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import axios from 'axios';
import { PRODUCT_CATEGORIES } from '../../config/categories';

const toUrlSlug = (name) => {
  return name.toLowerCase().replace(/\s+/g, '-');
};

const CategorySidebar = ({ activeCategory }) => {
  const [latestProducts, setLatestProducts] = useState([]);

  useEffect(() => {
    // Fetch all products and filter for the latest in "Dialysis Supplies"
    const fetchLatest = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/products`);
        const dialysisProducts = response.data
          .filter(p => p.category === 'Dialysis Supplies')
          .slice(0, 3); // Get the top 3 latest (assuming data is sorted by date desc)
        setLatestProducts(dialysisProducts);
      } catch (error) {
        console.error("Could not fetch latest products", error);
      }
    };
    fetchLatest();
  }, []);

  return (
    <aside className="category-sidebar">
      <h4>Product Categories</h4>
      <ul className="category-list">
        {/* ... (The main category list is unchanged) ... */}
        <li>
          <NavLink to="/products" className={({isActive}) => (isActive && !activeCategory) ? 'active' : ''} end>
            All Products
          </NavLink>
        </li>
        {PRODUCT_CATEGORIES.map(category => (
          <li key={category}>
            <NavLink to={`/products/${toUrlSlug(category)}`} className={({isActive}) => isActive ? 'active' : ''}>
              {category}
            </NavLink>
          </li>
        ))}
      </ul>

      {/* --- NEW: Latest Products Section --- */}
      <div className="latest-products-section">
        <h4>Latest Products</h4>
        <ul className="latest-products-list">
          {latestProducts.map(product => (
            <li key={product.id}>
              <Link to={`/products/${toUrlSlug(product.category)}`} className="latest-product-item">
                <img src={product.imageUrl || '/images/placeholder.png'} alt={product.name} />
                <span>{product.name}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default CategorySidebar;